<template>
    <!-- 微信支付 -->
    <div>
        <!-- v-show="$route.meta.showFather" -->
        <div class="pad-16 mb-16 box-shadow" style="margin-top: 16px;">
            <div class="is-flex mb-24">
                <div class="left-icon"></div>
                <p class="left-p">支付方式</p>
            </div>
            <div class="is-flex jus-bet te-c">
                <div></div>
                <div>
                    <img src="../../assets/head/wx-pay.png" alt="" class="wxzf mb-16">
                    <div class="code" id="qrcode" ref="qrcode"
                        style="width: 6.25rem;margin: 0 auto;margin-bottom: 1rem;"></div>
                    <!-- <img src="../../../src/assets/head/QR Code.png" alt="" class="erweima mb-16" @click="wxpay"> -->
                    <div class="is-flex apply">
                        <p>总计:</p>
                        <p>¥&nbsp;{{price}}</p>
                    </div>
                </div>
                <div></div>

            </div>
        </div>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2';
    import {
        getRegistration,
    } from '@/api/activity/api.js';
    export default {
        components: {
            QRCode
        },
        data() {
            return {
                infoShow: true,
                taus: '',
                displayContent: '',
                price: '',
				id:'',
            }
        },
        created() {

        },
        mounted() {
            this.displayContent = this.$route.params.displayContent;
            this.price = this.$route.params.price;
			this.id = this.$route.params.id;
            this.qrcode(this.displayContent);
            this.startPolling()
            // this.timer = setInterval(this.getStatus(this.$route.params.id), 2000);
            // this.getStatus(this.$route.params.id);
        },
        methods: {
            qrcode(displayContent) {
                this.qrcode = new QRCode('qrcode', {
                    text: displayContent,
                    // weixin://wxpay/bizpayurl?pr=8x9qDPPzz
                    width: 100,
                    height: 100,
                });
            },
            startPolling() {
                this.intervalId = setInterval(() => {
                    this.getStatus(this.$route.params.id)
                }, 5000) // 每隔3秒钟轮询一次
            },
            stopPolling() {
                clearInterval(this.intervalId)
            },

            getStatus(id) {
                getRegistration({
                        id: id
                    }).then(res => {
                        console.log(res.data.payStatus, '支付状态')
                        // 0是未支付 1成功 2取消
                        let payStatus = res.data.payStatus;
                        if (payStatus === 1) {
                            console.log('--')
                            this.stopPolling();
                            this.$router.push({
                                name: '/activity/paymentSuccess',
                                params: {
                                    payStatus: payStatus,
									id:this.id,
                                }
                            })
                        } else if(payStatus == 2) {
                            this.stopPolling();
                            this.$router.push({
                                name: '/activity/paymentFail',
                                params: {
                                    payStatus: payStatus,
									id:this.id,
                                }
                            })
                        }else{
                            
                        }
                        // this.form = res.data;
                    })
                    .catch(error => {

                    });
            },



            wxpay() {
                this.taus = 1;
                if (this.taus = 1) {
                    this.$router.push('/activity/paymentSuccess')
                    // console.log(this.$route.matched,'----this.$route.matched')
                    // this.$route.matched[4].meta.title = '11111'
                } else {
                    this.$router.push('/activity/paymentFail')
                }
            }
        },
        beforeDestroy() {
            document.getElementById('qrcode').innerHTML = "";
            this.stopPolling()
        }
    }
</script>


<style scoped>
    .pad-16 {
        padding: 32px 16px;

    }

    .box-shadow {
        box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
        border-radius: 8px 8px 8px 8px;
    }

    .is-flex {
        display: flex;
        align-items: center;
    }

    .jus-bet {
        justify-content: space-between;
    }


    .mb-24 {
        margin-bottom: 24px;
    }

    .mb-16 {
        margin-bottom: 16px;
    }

    .left-icon {
        width: 6px;
        height: 20px;
        background: #3377FF;
        border-radius: 18px;
    }

    .left-p {
        font-size: 20px;
        color: #222222;
        font-weight: normal;
        padding-left: 10px;
    }

    .wxzf {
        width: 5.5rem;
        height: 5.5rem;
    }

    .erweima {
        width: 6.25rem;
        height: 6.25rem;
    }

    .apply p:first-child {
        color: #222222;
        font-size: 14px;
        margin-right: 1rem;
    }

    .apply p:last-child {
        color: #FF5533;
        font-size: 28px;
    }

    .te-c {
        text-align: center;
    }
</style>
